import React from 'react';
import { Modal, Box, Typography, Grid, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

const VersionSelectorPopup = ({
  open,
  onClose,
  versionLinks,
  source
}: {
  open: boolean;
  onClose: () => void;
  versionLinks: { v3: string; v4: string };
  source:string;
}) => {
  const navigate = useNavigate();

  const handleVersionSelect = (url: string) => {
    onClose(); // Close the modal
    navigate(url); // Navigate to the selected version
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="body2" sx={{fontSize:"1rem", marginBottom:"1.5rem"}} gutterBottom align="center">
          Choose the version of {source}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => handleVersionSelect(versionLinks.v3)}
              sx={{ height: 80, backgroundColor:"#a06830",':hover':{backgroundColor:"#eec05cec"} }}
            >
              Version 3.1
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => handleVersionSelect(versionLinks.v4)}
              sx={{ height: 80, backgroundColor:"#353c52",':hover':{backgroundColor:"#95a3caff"} }}
            >
              Version 4.0
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default VersionSelectorPopup;
